// Largest file of the mass upload (Neu -> Massenupload), set as Volto's
// maxFileUploadSize. The files go to Plone in chunks over TUS, so neither the
// memory of the browser nor a proxy limit for the request body caps it; the
// Volto server buffers every download and gives up at 2e9 bytes. Plone refuses
// larger uploads with the same value, TUS_MAX_UPLOAD_SIZE in
// hornundhorn.contenttypes/config.py (#22832)
export const MAX_FILE_UPLOAD_SIZE = 1024 * 1024 * 1024;

// Largest file the file field of a form (Neu -> Datei, Neu -> Bild) takes.
// The form reads the file as base64 into the memory of the browser and sends
// it in one JSON request; Chrome gives up silently at about 383 MB (#22832)
export const FORM_FILE_UPLOAD_SIZE = 300 * 1024 * 1024;

// Bytes per PATCH request of a TUS upload. tus-js-client sends the whole file
// in one request without it
export const TUS_CHUNK_SIZE = 10 * 1024 * 1024;

// Milliseconds tus-js-client waits before it repeats a failed request, enough
// to outlast the restart of a backend replica
export const TUS_RETRY_DELAYS = [0, 1000, 3000, 5000, 10000, 20000];

/**
 * Size limit for messages, e.g. "1 GB" or "300 MB"
 * @param {number} size Bytes
 * @returns {string}
 */
export const formatUploadSize = (size) =>
  size >= 1024 * 1024 * 1024
    ? `${size / 1024 / 1024 / 1024} GB`
    : `${size / 1024 / 1024} MB`;
